import React from 'react';
import ModalButton from './ModalButton';

const InvalidFileModal = ({variant, closeModal})=>{
	return <div>
		<div>It doesn't look like that is a valid Jumbletree LEARN upload file!</div>
		{variant === "type" && <div>The file should be an XLSX file</div>}
		{variant === "size" && <div>The file should not be more than 1Mb</div>}
		<ModalButton text="Try again" onClick={closeModal} />
	</div>
}

export default InvalidFileModal;